import revisedArticleData from "@/content/revisedArticleData.json";
import lvmhArticleData from "@/content/lvmhArticleData.json";
import hsbcArticleData from "@/content/hsbcArticleData.json";

export const formatPublicationDate = (isoDate) => new Intl.DateTimeFormat("en-AU", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "UTC",
}).format(new Date(`${isoDate}T00:00:00Z`));

export const researchArticles = [hsbcArticleData, lvmhArticleData, ...revisedArticleData];

export const getResearchArticle = (slug) => researchArticles.find((article) => article.slug === slug);

const collectStrings = (value) => {
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(collectStrings).join(" ");
  if (value && typeof value === "object") return Object.entries(value)
    .filter(([key]) => !["src", "source", "path", "slug", "id", "sourceFile"].includes(key))
    .map(([, nestedValue]) => collectStrings(nestedValue))
    .join(" ");
  return "";
};

export const getReadTime = (article) => {
  if (article.readTimeOverride) return article.readTimeOverride;
  const wordCount = collectStrings(article.sections).trim().split(/\s+/).filter(Boolean).length;
  return `${Math.max(1, Math.ceil(wordCount / 220))} min read`;
};